module.exports = __webpack_public_path__ + "img/dummy-account.476909c0.jpg";